import React from 'react';

type ButtonVariant = 'primary' | 'gold' | 'ghost';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant;
  full?: boolean;
}

const variantStyles: Record<ButtonVariant, string> = {
  primary: 'bg-inverse text-ink-inverse hover:opacity-90 dark:bg-accent dark:text-accent-contrast',
  gold: 'bg-accent text-accent-contrast hover:opacity-90',
  ghost: 'bg-transparent text-ink border border-line-strong hover:bg-raised',
};

export const Button: React.FC<ButtonProps> = ({
  variant = 'primary',
  full = false,
  className = '',
  children,
  ...rest
}) => (
  <button
    className={`min-h-[44px] px-6 rounded-sm label-caps inline-flex items-center justify-center gap-2 transition-all disabled:opacity-50 disabled:cursor-not-allowed ${
      full ? 'w-full' : ''
    } ${variantStyles[variant]} ${className}`}
    {...rest}
  >
    {children}
  </button>
);
